import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { 
  DocumentsListParameters,
  TasksListParameters,
  PS_Lst_Tasks_V2_Result,
  PS_Lst_Documentaire_Result,
  SourcingParameters,
  PS_Sourcing_Result,
  Ps_Lst_Connections_Result,
} from '../all-models';
import { SharedDataService } from '../all-services';

@Injectable({
  providedIn: 'root'
})
export class ScreenListsService {
  ScreenlistsUrl: string;

  constructor(public sharedDataSvc: SharedDataService, private http: HttpClient) {
    this.ScreenlistsUrl = this.sharedDataSvc.apiBaseUrl + 'ScreenLists/';
   }

  public Sourcing(parameters:SourcingParameters): Observable<PS_Sourcing_Result[]> {
    parameters.LngCod=this.sharedDataSvc.lngCod||'FR';
    if (!parameters.CertOrQualifDocIds) parameters.CertOrQualifDocIds=[];
    if (!parameters.FamiliesIds) parameters.FamiliesIds=[];
    if (!parameters.NameOrNumTiers) parameters.NameOrNumTiers='';
    if (!parameters.RegionalPanels) parameters.RegionalPanels=[];
    return this.http.post<PS_Sourcing_Result[]>(this.ScreenlistsUrl + 'Sourcing',parameters);
  }
  public TasksList(parameters:TasksListParameters): Observable<PS_Lst_Tasks_V2_Result[]> {
    return this.http.post<PS_Lst_Tasks_V2_Result[]>(this.ScreenlistsUrl + 'TasksList',parameters);
  }
  
  public DocumentsList(parameters:DocumentsListParameters): Observable<PS_Lst_Documentaire_Result[]> {
    return this.http.post<PS_Lst_Documentaire_Result[]>(this.ScreenlistsUrl + 'DocumentsList',parameters);
  }

  
  public ConnexionsLists(portalType: string): Observable<Ps_Lst_Connections_Result[]> {
    return this.http.get<Ps_Lst_Connections_Result[]>( `${this.ScreenlistsUrl}LstConnexions/${portalType}/${this.sharedDataSvc.lngCod}`);
  }
  public EncoursList(): Observable<PS_Lst_Tasks_V2_Result[]> {
    return this.http.post<PS_Lst_Tasks_V2_Result[]>(this.ScreenlistsUrl + 'EncoursList',null);
  }
}
